<template>
  <div class="modal is-visible">
    <div class="modal-wrapper modal-transition">
      <div class="modal-body">
        <div class="modal-content">
          <div class="msg-text">
            <p>
              원하시는 상담 유형을 선택해 주세요.
            </p>
            <div class="support-box">
              <button
                type=""
                class="btn btn-modal modal-open"
                data-idx="0"
                @click="clickSelButton"
              >
                고교취업 지원
              </button>
              <button
                type=""
                class="btn btn-modal modal-open"
                data-idx="1"
                @click="clickSelButton"
              >
                희망사다리
                <BR />
                장학지원
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type=""
          class="btn btn-primary modal-toggle"
          @click="clickCloseButton"
        >
          닫기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pgmobj"],
  computed: {},
  methods: {
    clickSelButton(event) {
      const evtObj = $(event.target).closest("button");
      const selIdx = parseInt(evtObj.data("idx"));

      this.$emit("close", selIdx);
    },
    clickCloseButton() {
      this.$emit("close");
    }
  }
};
</script>
